<div class="row page-titles">
    <div class="col-12 col-md-6 align-self-center">
        <h3 class="text-themecolor">
            <i class="text-secondary fa-solid fa-arrows-split-up-and-left mr-2"></i>Mover artículo de ubicación
        </h3>
    </div>
</div>

<div class="row animated fadeIn fast">
    <div class="col-12">
        <form [formGroup]="moverForm"
            autocomplete="off">

            <!-- ========================================================= -->
            <!-- PASO 1: Ubicación de Origen -->
            <!-- ========================================================= -->
            <div class="card border mb-3"
                [ngClass]="{
                    'paso-desactivado': ubiOrigenValida,
                    'border-danger': errorOrigen,
                    'border-info': !ubiOrigenValida && !errorOrigen
                 }">
                <div class="card-header d-flex no-block justify-content-between align-items-center bg-light">
                    <h5 class="mb-0 paso-titulo text-truncate mr-2">
                        <i class="fa-solid fa-1 mr-1"></i>
                        <i class="fa-solid fa-location-dot mr-1"></i> Ubicación de Origen
                    </h5>
                    <div class="d-flex no-block align-items-center header-acciones-paso ml-auto" *ngIf="ubiOrigenValida">
                        <span class="badge badge-secondary font-weight-bold">
                            <i class="fa-solid fa-check mr-1"></i>Origen Válido
                        </span>
                        <button type="button"
                            class="btn btn-xs btn-outline-secondary btn-cambiar-paso ml-2"
                            title="Cambiar ubicación origen"
                            (click)="cambiarOrigen()">
                            <i class="fa-solid fa-pencil mr-1"></i>Cambiar
                        </button>
                    </div>
                </div>

                <div class="card-body p-3">
                    <div class="form-group mb-2">
                        <label class="form-control-label font-weight-bold" [class.text-muted]="ubiOrigenValida">
                            Ubicación Origen:
                        </label>
                        <div class="input-group">
                            <input #txtUbiOrigen
                                type="text"
                                formControlName="ubiOrigen"
                                [readonly]="loadingOrigen || ubiOrigenValida"
                                class="form-control form-control-lg text-monospace font-weight-bold"
                                [ngClass]="{
                                       'is-valid': ubiOrigenValida,
                                       'is-invalid': errorOrigen
                                   }"
                                maxlength="17"
                                mask="00.00.00.00.00.00"
                                placeholder="00.00.00.00.00.00"
                                (input)="onUbiOrigenInput()"
                                (keyup.enter)="validarUbiOrigen()"
                                (blur)="validarUbiOrigen()">

                            <div class="input-group-append">
                                <button type="button"
                                    class="btn btn-info"
                                    [disabled]="loadingOrigen || ubiOrigenValida"
                                    (click)="validarUbiOrigen()">
                                    <i *ngIf="loadingOrigen" class="fa-solid fa-spinner fa-spin mr-1"></i>
                                    <i *ngIf="!loadingOrigen" class="fa-solid fa-search mr-1"></i> Validar
                                </button>
                            </div>
                        </div>

                        <!-- Errores origen -->
                        <div *ngIf="errorOrigen" class="text-danger mt-1 font-weight-bold small">
                            <i class="fa-solid fa-circle-exclamation mr-1"></i>{{ errorOrigen }}
                        </div>

                        <!-- Información descifrada origen -->
                        <!-- <div *ngIf="codUbiOriDecript" class="alert alert-secondary py-1 px-2 mt-2 mb-0 small">
                            <i class="fa-solid fa-circle-info mr-1 text-info"></i>
                            <strong>Detalle:</strong>  
                            {{ codUbiOriDecript }}
                            <span *ngIf="clienteOrigen" class="ml-2 badge badge-info">{{ clienteOrigen }}</span>
                        </div> -->
                    </div>

                    <!-- Listado de Artículos en Ubicación Origen (Acordeón colapsado por defecto) -->
                    <div *ngIf="ubiOrigenValida && stockOrigenList.length > 0" class="mt-3">
                        <div class="card border border-info mb-0 accordion-articulos">
                            <div class="card-header bg-light p-0 pointer"
                                (click)="toggleStockOrigen()"
                                [attr.aria-expanded]="mostrarStockOrigen">
                                <div class="font-weight-bold text-dark d-flex justify-content-between align-items-center w-100 flex-nowrap py-2 px-3">
                                    <div class="d-flex align-items-center text-truncate mr-2 flex-nowrap">
                                        <i class="fa-solid fa-boxes-stacked text-secondary mr-2 flex-shrink-0"></i>
                                        <span class="text-truncate">Artículos</span>
                                        <span class="badge badge-info ml-2 font-weight-bold flex-shrink-0">{{ stockOrigenList.length }}</span>

                                        <span *ngIf="clienteOrigen" class="ml-2 badge badge-info">{{ clienteOrigen }}</span>

                                        <i class="fa-solid ml-2 text-secondary flex-shrink-0" [ngClass]="mostrarStockOrigen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="collapse" [class.show]="mostrarStockOrigen">
                                <div class="card-body p-2 bg-white border-top">

                                    <div class="table-responsive">
                                        <table class="table table-sm table-hover table-bordered mb-0 table-articulos-ubi">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>EAN</th>
                                                    <th>Sku</th>
                                                    <th class="text-center">Disp.</th>
                                                    <th class="text-center">Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngFor="let item of stockOrigenList">
                                                    <tr [class.table-primary]="stockSelected?.id === item.id"
                                                        (click)="seleccionarArticuloDeTabla(item)"
                                                        class="pointer articulo-main-row">
                                                        <td class="font-weight-bold text-monospace col-ean small">{{ item.articuloEan }}</td>
                                                        <td class="col-sku small">{{ item.articuloSku }}</td>
                                                        <td class="text-center font-weight-bold text-primary">
                                                            {{ item.cantidadDisponible !== undefined ? item.cantidadDisponible : item.cantidad }}
                                                        </td>
                                                        <td class="text-center">
                                                            <button type="button"
                                                                class="btn btn-xs"
                                                                [ngClass]="stockSelected?.id === item.id ? 'btn-primary' : 'btn-outline-primary'"
                                                                (click)="seleccionarArticuloDeTabla(item); $event.stopPropagation()">
                                                                <i class="fa-solid fa-check mr-1"></i>
                                                                {{ stockSelected?.id === item.id ? 'Seleccionado' : 'Elegir' }}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    <tr [class.table-primary]="stockSelected?.id === item.id"
                                                        (click)="seleccionarArticuloDeTabla(item)"
                                                        class="pointer articulo-desc-row">
                                                        <td colspan="4" class="text-muted small pt-0 border-top-0">
                                                            {{ item.articuloDescripcion || item.descripcion }}
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ========================================================= -->
            <!-- PASO 2: Artículo (EAN) y Cantidad -->
            <!-- ========================================================= -->
            <div *ngIf="ubiOrigenValida"
                class="card border mb-3 animated fadeIn fast"
                [ngClass]="{
                    'paso-desactivado': stockSelected,
                    'border-danger': errorEan,
                    'border-info': !stockSelected && !errorEan
                 }">
                <div class="card-header d-flex no-block justify-content-between align-items-center bg-light">
                    <h5 class="mb-0 paso-titulo text-truncate mr-2">
                        <i class="fa-solid fa-2 mr-1"></i>
                        <i class="fa-solid fa-barcode mr-1"></i> Artículo a Mover
                    </h5>
                    <div class="d-flex no-block align-items-center header-acciones-paso ml-auto" *ngIf="stockSelected">
                        <span class="badge badge-secondary font-weight-bold">
                            <i class="fa-solid fa-check mr-1"></i>Artículo Válido
                        </span>
                        <button type="button"
                            class="btn btn-xs btn-outline-secondary btn-cambiar-paso ml-2"
                            title="Cambiar artículo seleccionado"
                            (click)="cambiarArticulo()">
                            <i class="fa-solid fa-pencil mr-1"></i>Cambiar
                        </button>
                    </div>
                </div>

                <div class="card-body p-3">
                    <div class="row">
                        <!-- Input EAN -->
                        <div class="col-12 col-md-6 mb-2">
                            <label class="form-control-label font-weight-bold" [class.text-muted]="stockSelected">
                                EAN:
                            </label>
                            <div class="input-group">
                                <input #txtEan
                                    type="text"
                                    formControlName="ean"
                                    [readonly]="!!stockSelected"
                                    class="form-control form-control-lg text-monospace"
                                    [ngClass]="{
                                           'is-valid': stockSelected,
                                           'is-invalid': errorEan
                                       }"
                                    placeholder="Escanear código EAN..."
                                    (keyup.enter)="validarEan()"
                                    (blur)="validarEan()">

                                <div class="input-group-append">
                                    <button type="button"
                                        class="btn btn-info"
                                        [disabled]="!!stockSelected"
                                        (click)="validarEan()">
                                        <i class="fa-solid fa-barcode mr-1"></i> Validar EAN
                                    </button>
                                </div>
                            </div>

                            <!-- Error EAN / Múltiples Lotes -->
                            <div *ngIf="errorEan" class="alert alert-danger mt-2 py-2 px-3 small font-weight-bold">
                                <i class="fa-solid fa-triangle-exclamation mr-1 fa-lg"></i>
                                {{ errorEan }}
                            </div>
                        </div>

                        <!-- Cantidad -->
                        <div class="col-12 col-md-6 mb-2" *ngIf="stockSelected">
                            <label class="form-control-label font-weight-bold text-dark">
                                Cantidad a mover <span class="text-muted font-weight-normal">(Máximo disponible: {{ getMaximoDisponible() }})</span>
                            </label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button type="button"
                                        class="btn btn-outline-secondary btn-cantidad"
                                        [disabled]="(moverForm.get('cantidad')?.value || 0) <= 1"
                                        (click)="ajustarCantidad(-1)">
                                        <i class="fa-solid fa-minus"></i>
                                    </button>
                                </div>

                                <input #txtCantidad
                                    type="number"
                                    formControlName="cantidad"
                                    class="form-control form-control-lg text-center font-weight-bold fs-18 input-cantidad"
                                    min="1"
                                    [max]="getMaximoDisponible()"
                                    (keyup.enter)="focoUbiDestino()">

                                <div class="input-group-append">
                                    <button type="button"
                                        class="btn btn-outline-secondary btn-cantidad"
                                        [disabled]="(moverForm.get('cantidad')?.value || 0) >= getMaximoDisponible()"
                                        (click)="ajustarCantidad(1)">
                                        <i class="fa-solid fa-plus"></i>
                                    </button>
                                    <button type="button"
                                        class="btn btn-outline-info btn-cantidad"
                                        [disabled]="(moverForm.get('cantidad')?.value || 0) >= getMaximoDisponible()"
                                        title="Mover todo"
                                        (click)="setCantidadMaxima()">
                                        Todo ({{ getMaximoDisponible() }})
                                    </button>
                                </div>
                            </div>

                            <small *ngIf="moverForm.get('cantidad')?.errors?.['max']" class="text-danger font-weight-bold">
                                La cantidad no puede ser mayor que {{ getMaximoDisponible() }}.
                            </small>
                            <small *ngIf="moverForm.get('cantidad')?.errors?.['min']" class="text-danger font-weight-bold">
                                La cantidad mínima es 1.
                            </small>
                        </div>
                    </div>

                    <!-- Ficha del Artículo Seleccionado -->
                    <div *ngIf="stockSelected" class="card bg-light border-info mt-2 mb-0">
                        <div class="card-body p-2">
                            <div class="d-flex align-items-center">
                                <!-- <div class="mr-3 text-center" *ngIf="stockSelected.articulo?.foto">
                                    <img [src]="fotoDir +'/articulos' +  stockSelected.articulo?.foto"
                                        loading="lazy"
                                        alt="Foto"
                                        style="max-height: 65px; max-width: 65px; object-fit: contain;"
                                        class="rounded border bg-white p-1">
                                </div> -->
                                <div class="flex-grow-1">
                                    <h5 class="mb-1 text-info font-weight-bold">
                                        {{ stockSelected.articuloDescripcion || stockSelected.descripcion }}
                                    </h5>
                                    <div class="small">
                                        <span class="mr-3"><strong>EAN:</strong> {{ stockSelected.articuloEan }}</span>
                                        <span class="mr-3" *ngIf="stockSelected.articuloSku"><strong>Ref / SKU:</strong> {{ stockSelected.articuloSku }}</span>
                                        <span *ngIf="stockSelected.lote || stockSelected.fechaCaducidad" class="mr-3">
                                            <span *ngIf="stockSelected.lote"><strong>Lote:</strong> <span class="badge badge-dark">{{ stockSelected.lote }}</span></span>
                                            <span *ngIf="stockSelected.fechaCaducidad"><strong>Caducidad:</strong> {{ stockSelected.fechaCaducidad | date:'dd/MM/yyyy' }}</span>
                                        </span>
                                        <span class="badge badge-info" *ngIf="stockSelected.clienteNombre">{{ stockSelected.clienteNombre }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ========================================================= -->
            <!-- PASO 3: Ubicación de Destino -->
            <!-- ========================================================= -->
            <div *ngIf="stockSelected"
                class="card border mb-3 animated fadeIn fast"
                [ngClass]="{
                    'border-success': ubiDestinoValida,
                    'border-danger': errorDestino,
                    'border-info': !ubiDestinoValida && !errorDestino
                 }">
                <div class="card-header d-flex no-block justify-content-between align-items-center"
                    [ngClass]="{
                        'bg-success text-white': ubiDestinoValida,
                        'bg-danger text-white': errorDestino,
                        'bg-light': !ubiDestinoValida && !errorDestino
                     }">
                    <h5 class="mb-0 paso-titulo text-truncate mr-2">
                        <i class="fa-solid fa-3 mr-1"></i>
                        <i class="fa-solid fa-location-dot mr-1"></i> Ubicación Destino
                    </h5>
                    <div class="d-flex no-block align-items-center header-acciones-paso ml-auto" *ngIf="ubiDestinoValida">
                        <span *ngIf="destinoLibre" class="badge badge-light text-success font-weight-bold">
                            <i class="fa-solid fa-check mr-1"></i>Destino Vacío
                        </span>
                        <span *ngIf="!destinoLibre && clienteDestino" class="badge badge-light text-primary font-weight-bold">
                            <i class="fa-solid fa-check mr-1"></i>{{ clienteDestino }}
                        </span>
                    </div>
                </div>

                <div class="card-body p-3">
                    <div class="form-group mb-2">
                        <label class="form-control-label font-weight-bold">
                            Ubicación Destino:
                        </label>
                        <div class="input-group">
                            <input #txtUbiDestino
                                type="text"
                                formControlName="ubiDestino"
                                class="form-control form-control-lg text-monospace font-weight-bold"
                                [ngClass]="{
                                       'is-valid': ubiDestinoValida,
                                       'is-invalid': errorDestino
                                   }"
                                maxlength="17"
                                mask="00.00.00.00.00.00"
                                placeholder="00.00.00.00.00.00"
                                (input)="onUbiDestinoInput()"
                                (keyup.enter)="validarUbiDestino()">

                            <div class="input-group-append">
                                <button type="button"
                                    class="btn btn-info"
                                    [disabled]="loadingDestino"
                                    (click)="validarUbiDestino()">
                                    <i *ngIf="loadingDestino" class="fa-solid fa-spinner fa-spin mr-1"></i>
                                    <i *ngIf="!loadingDestino" class="fa-solid fa-search mr-1"></i> Validar
                                </button>
                            </div>
                        </div>

                        <!-- Error destino -->
                        <div *ngIf="errorDestino" class="alert alert-danger mt-2 py-2 px-3 small font-weight-bold">
                            <i class="fa-solid fa-triangle-exclamation mr-1 fa-lg"></i>
                            {{ errorDestino }}
                        </div>

                        <!-- Información descifrada destino -->
                        <!-- <div *ngIf="codUbiDesDecript" class="alert alert-secondary py-1 px-2 mt-2 mb-0 small">
                             <i class="fa-solid fa-circle-info mr-1 text-info"></i>
                            <strong>Detalle:</strong>  
                            {{ codUbiDesDecript }}
                            <span *ngIf="destinoLibre" class="badge badge-success ml-2">Ubicación vacía (0 artículos)</span>
                            <span *ngIf="!destinoLibre && clienteDestino && !errorDestino" class="badge badge-info ml-2">{{ clienteDestino }}</span>
                        </div> -->
                    </div>

                    <!-- Listado de Artículos en Ubicación Destino -->
                    <div *ngIf="destinoLibre && ubiDestinoValida" class="mt-3">
                        <div class="alert alert-success py-2 px-3 mb-0 font-weight-bold">
                            <i class="fa-solid fa-circle-check mr-1"></i>
                            La ubicación de destino está vacía (0 artículos)
                        </div>
                    </div>

                    <!-- Listado de Artículos en Ubicación Destino (Acordeón colapsado por defecto) -->
                    <div *ngIf="stockDestinoList.length > 0" class="mt-3">
                        <div class="card border border-info mb-0 accordion-articulos">
                            <div class="card-header bg-light p-0 pointer"
                                (click)="toggleStockDestino()"
                                [attr.aria-expanded]="mostrarStockDestino">
                                <div class="font-weight-bold text-dark d-flex justify-content-between align-items-center w-100 flex-nowrap py-2 px-3">
                                    <div class="d-flex align-items-center text-truncate mr-2 flex-nowrap">
                                        <i class="fa-solid fa-boxes-stacked text-info mr-2 flex-shrink-0"></i>
                                        <span class="text-truncate">Artículos</span>
                                        <span class="badge badge-info ml-2 font-weight-bold flex-shrink-0">{{ stockDestinoList.length }}</span>

                                        <i class="fa-solid ml-2 text-secondary flex-shrink-0" [ngClass]="mostrarStockDestino ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="collapse" [class.show]="mostrarStockDestino">
                                <div class="card-body p-2 bg-white border-top">
                                    <div class="table-responsive">
                                        <table class="table table-sm table-bordered mb-0 bg-white table-articulos-ubi">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>EAN</th>
                                                    <th>Sku</th>
                                                    <th>Cliente</th>
                                                    <th class="text-center">Cant. Actual</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngFor="let destItem of stockDestinoList">
                                                    <tr [class.table-danger]="esClienteIncompatible(destItem)"
                                                        class="articulo-main-row">
                                                        <td class="font-weight-bold text-monospace col-ean small">{{ destItem.articuloEan }}</td>
                                                        <td class="col-sku small">{{ destItem.articuloSku }}</td>
                                                        <td>
                                                            <span class="badge" [ngClass]="esClienteIncompatible(destItem) ? 'badge-danger' : 'badge-info'">
                                                                {{ destItem.clienteNombre || 'Sin cliente' }}
                                                            </span>
                                                        </td>
                                                        <td class="text-center font-weight-bold">{{ destItem.cantidad }}</td>
                                                    </tr>
                                                    <tr [class.table-danger]="esClienteIncompatible(destItem)"
                                                        class="articulo-desc-row">
                                                        <td colspan="4" class="text-muted small pt-0 border-top-0">
                                                            {{ destItem.articuloDescripcion || destItem.descripcion }}
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ========================================================= -->
            <!-- PASO 4: Botonera de Acción -->
            <!-- ========================================================= -->
            <div class="botones-accion d-flex justify-content-between align-items-center w-100 mb-4">

                <button type="button"
                    class="btn waves-effect waves-light btn-rounded btn-secondary"
                    (click)="cancelarMovimiento()">
                    <i class="fa-solid fa-xmark mr-1"></i> Cancelar
                </button>

                <button *ngIf="puedeConfirmar()" type="button"
                    class="btn waves-effect waves-light btn-rounded btn-success"
                    (click)="confirmarMovimiento()">
                    <i *ngIf="loadingGuardar" class="fa-solid fa-spinner fa-spin mr-1"></i>
                    <i *ngIf="!loadingGuardar" class="fa-solid fa-arrow-right-arrow-left mr-1"></i>
                    Confirmar
                </button>

            </div>

        </form>
    </div>
</div>